import { z } from "zod";

export const WarningCodeSchema = z.enum([
  "ANIM_EFFECT_FALLBACK",
  "ANIM_TARGET_MISSING",
  "ANIM_INTERACTIVE_SKIPPED",
  "ANIM_BOOKMARK_TRIGGER_SKIPPED",
  "ANIM_CHARRANGE_COLLAPSED",
  "ANIM_UNPARSEABLE",
  "TRANSITION_UNSUPPORTED",
  "FONT_SUBSTITUTED",
  "FONT_EMBEDDED_IGNORED",
  "FONT_SYMBOL_MAPPED",
  "GEOMETRY_UNSUPPORTED",
  "FILL_PATTERN_APPROXIMATED",
  "EFFECT_DROPPED",
  "MEDIA_FORMAT_UNSUPPORTED",
  "MEDIA_TOO_LARGE",
  "MEDIA_MISSING",
  "MEDIA_LINKED_EXTERNAL",
  "MEDIA_CODEC_UNSUPPORTED",
  "MEDIA_SAFARI_LIMITED",
  "MEDIA_UNSUPPORTED_SOURCE",
  "MEDIA_TRANSCODE_QUEUED",
  "MEDIA_TRANSCODE_FAILED",
  "MEDIA_TRANSCODE_SKIPPED",
  "MEDIA_IMAGE_DOWNSCALED",
  "ELEMENT_UNSUPPORTED",
  "TABLE_STYLE_APPROXIMATED",
  "SMARTART_FROM_FALLBACK",
  "CHART_APPROXIMATED",
  "SLIDE_PARSE_FAILED",
  "LAYOUT_MISSING",
  "XML_UNEXPECTED",
]);
export type WarningCode = z.infer<typeof WarningCodeSchema>;

export const ConversionWarningSchema = z.object({
  code: WarningCodeSchema,
  severity: z.enum(["info", "warning", "error"]),
  page: z.number().int().optional(),
  elementId: z.string().optional(),
  elementName: z.string().optional(),
  message: z.string(),
  detail: z.record(z.unknown()).optional(),
});
export type ConversionWarning = z.infer<typeof ConversionWarningSchema>;

/** Collects warnings with (code, page, elementId) dedupe and a hard cap. */
export class WarningSink {
  readonly items: ConversionWarning[] = [];
  private seen = new Set<string>();
  private overflow = 0;
  constructor(private readonly cap = 500) {}

  add(w: ConversionWarning): void {
    const key = `${w.code}|${w.page ?? ""}|${w.elementId ?? ""}`;
    if (this.seen.has(key)) return;
    this.seen.add(key);
    if (this.items.length >= this.cap) {
      this.overflow++;
      return;
    }
    this.items.push(w);
  }

  finish(): ConversionWarning[] {
    if (this.overflow > 0) {
      return [
        ...this.items,
        { code: "XML_UNEXPECTED", severity: "info", message: `…and ${this.overflow} more warnings` },
      ];
    }
    return this.items;
  }
}
